import * as React from "react";
const BreadcrumbList = ({ breadcrumbs }) => {
  const breadcrumbsList = breadcrumbs.map((crumb, index) => {
    const crumbImage = { image: crumb.image };
    return {
      "@type": "ListItem",
      position: index + 1,
      item: {
        "@id": crumb.url,
        name: crumb.name,
        ...crumbImage
      }
    };
  });
  if (breadcrumbsList.length < 1) {
    return null;
  }
  const payload = {
    "@context": "http://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [...breadcrumbsList]
  };
  return /* @__PURE__ */ React.createElement(
    "script",
    {
      type: "application/ld+json",
      dangerouslySetInnerHTML: { __html: JSON.stringify(payload) }
    }
  );
};
export {
  BreadcrumbList
};
//# sourceMappingURL=BreadcrumbList.sd.js.map
